import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useSessionStore } from '@/stores/SessionStore'
import { useCachedFetch } from '@/composables/useFetch'

import useConfigurationGlobals from '@/composables/useConfigurationGlobals'

const { $TEMPESTRESTAPIURL, $TEMPESTAPIKEY } = useConfigurationGlobals()

export let useAlertStore = defineStore('alertStore', () => {
  const sessionStore = useSessionStore();

  let alerts = ref(null);

  const hasAlerts = computed(() => alerts.value && alerts.value.length > 0)
  const alertCount = computed(() => alerts.value.length)

  async function getAdvisoryByLatLon(lat, lon) {
    const settings = {
      lat,
      lon,
      wf_token: sessionStore.token,
      api_key: $TEMPESTAPIKEY
    }

    const queryString = new URLSearchParams(settings).toString()
    const url = `${$TEMPESTRESTAPIURL}/alerts?${queryString}`

    try {
      const { error, data } = await useCachedFetch(url)

      if (error.value) {
        throw error.value
      }

      if (data.value.status?.status_code !== 0 && data.value.status_code !== 0) {
        throw data.value.status || data.value.status_code
      }

      alerts.value = data.value.alerts;

      return alerts.value
    } catch (error) {
      console.warn(error)

      return error
    }
  }

  return {
    alerts,
    hasAlerts,
    alertCount,
    getAdvisoryByLatLon
  }
})
